export var AbortTypes;
(function (AbortTypes) {
    /**
     * 没有中止类型。即使其他条件更改了状态，当前操作也将始终运行
     */
    AbortTypes[AbortTypes["None"] = 0] = "None";
    /**
     * 如果一个更重要的有条件的任务改变了状态，它可以发出一个中止指令，使低优先级的任务停止运行，并将控制权转回高优先级的分支。
     * 这种类型应该被设置在作为讨论中的复合体的子体的复合体上。
     * 父复合体将检查它的子体，看它们是否有LowerPriority中止。
     */
    AbortTypes[AbortTypes["LowerPriority"] = 1] = "LowerPriority";
    /**
     * 只有当它们都是复合体的子任务时，条件任务才能中止一个行动任务。
     * 这个AbortType只影响它所设置的实际的Composite，不像LowerPriority会影响其父Composite。
     */
    AbortTypes[AbortTypes["Self"] = 2] = "Self";
    /**
     * 检查LowerPriority和Self aborts
     */
    AbortTypes[AbortTypes["Both"] = 3] = "Both";
})(AbortTypes || (AbortTypes = {}));
export class AbortTypesExt {
    static has(self, check) {
        return (self & check) == check;
    }
}
//# sourceMappingURL=AbortTypes.js.map